import React from 'react';
import { useForm } from 'react-hook-form';
import { meUpdate } from '../../api';
import { handleGlobalApiCalls, syncUser } from '../../helpers/asyncActions';
import { useGlobalContext } from '../../stores/global';
import Button from '../core/Button';
import FormElement from '../core/FormElement';
import Modal from './Modal';

export interface Props {
  onClose: () => void;
  onSubmit?: () => void;
  open: boolean;
  user: any;
}

const banks = [
  { name: 'Bancolombia', value: 'Bancolombia' },
  { name: 'Banco de Bogotá', value: 'Banco de Bogotá' },
  { name: 'Davivienda', value: 'Davivienda' },
  { name: 'BBVA', value: 'BBVA' },
  { name: 'Banco de Occidente', value: 'Banco de Occidente' },
  { name: 'Banco Itaú', value: 'Banco Itaú' },
  { name: 'Colpatria', value: 'Colpatria' },
  { name: 'Banco Popular', value: 'Banco Popular' },
  { name: 'Banco Caja Social', value: 'Banco Caja Social' },
  { name: 'Banco AV Villas', value: 'Banco AV Villas' },
  { name: 'Scotiabank', value: 'Scotiabank' },
];

const bankTypes = [
  { name: 'Cuenta de ahorros', value: 'Ahorros' },
  { name: 'Cuenta corriente', value: 'Corriente' },
];

export default function BankAccountModal({
  onClose,
  open,
  user,
  onSubmit,
}: Props) {
  if (!open || !user) return null;

  const { isLoading, dispatch } = useGlobalContext();

  const { handleSubmit, register, errors } = useForm({
    defaultValues: {
      bank: user.bankAccount?.bank || '',
      account: user.bankAccount?.account || '',
      type: user.bankAccount?.type || '',
    },
  });

  const handleFormSubmit = (data: any) => {
    handleGlobalApiCalls(dispatch, isLoading, null, async () => {
      await meUpdate({ bankAccount: data });
      await syncUser(dispatch);
      onSubmit?.();
      onClose();
    });
  };

  return (
    <Modal open={open} title="Cuenta bancaria" onClose={onClose} closeBtn>
      <div>
        <p style={{ marginBottom: 30 }}>
          Coloca los datos bancarios donde el comprador realizará el pago
        </p>

        <form onSubmit={handleSubmit(handleFormSubmit)}>
          <FormElement
            name="bank"
            label="Banco"
            placeholder="Banco"
            inputRef={register({ required: true })}
            error={errors.bank}
            elementType="select"
            options={banks}
          />
          <FormElement
            name="account"
            label="Número de cuenta"
            placeholder="Número de cuenta"
            inputRef={register({ required: true })}
            error={errors.account}
            elementType="number"
          />

          <FormElement
            name="type"
            label="Tipo de cuenta"
            placeholder="Tipo de cuenta"
            inputRef={register({ required: true })}
            error={errors.type}
            elementType="select"
            options={bankTypes}
          />

          <Button label="ACEPTAR" type="submit" />
        </form>
      </div>
    </Modal>
  );
}
